import store from '../store/index.js'

import * as localForage from "localforage";

const merge_local_state = function(server_orders, local_modifications) {
  // Clone to not mutate argument
  const merged = JSON.parse(JSON.stringify(server_orders))
  for (const oid of Object.keys(local_modifications)) {
    if (!Object.hasOwn(merged, oid)) continue
    const should_merge_hidden_state = merged[oid].items.every(
      i => Object.hasOwn(local_modifications[oid].items, i.row_id)
    )
    if (should_merge_hidden_state) merged[oid].hidden = local_modifications[oid].hidden
    for (const item of merged[oid].items) {
      if (!Object.hasOwn(local_modifications[oid].items, item.row_id)) continue
      item.status = local_modifications[oid].items[item.row_id]
    }
  }
  return merged
}

const orders_transformer = async function(response) {
  let orders = response?.data.reduce(
    (acc, cur) => ({ ...acc, [cur.offline_pos_name]: cur}), {}
  )

  if (store.state?.settings?.syncing) {
    await localForage.removeItem("non-syncing-kds-modifications")
  } else {
    const local_mods_json = await localForage.getItem("non-syncing-kds-modifications")
    if (local_mods_json) {
      orders = merge_local_state(orders, JSON.parse(local_mods_json))
    }
  }

  return orders
}

export default orders_transformer
